import React from "react";
import { useNavigate } from "react-router";

const TripCard = ({ data }) => {
  // history for routing
  const history = useNavigate();
  const userInfo = JSON.parse(localStorage.getItem("wemoovezUserProfile"));

  const moversVehicle = `${data?.numberOfMovers ? data.numberOfMovers + " movers | " : ""}${
    data?.vehicle?.title || ""
  }`;

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    try {
      // strip off any time portion if present (e.g. "2/23/2026 12:00:00 AM" or ISO with T)
      const dateOnly = String(dateStr).split("T")[0].split(" ")[0];
      // support formats like MM/DD/YYYY
      if (dateOnly.includes("/")) {
        const parts = dateOnly.split("/");
        if (parts.length >= 3) {
          const m = parseInt(parts[0], 10);
          const d = parseInt(parts[1], 10);
          const y = parseInt(parts[2], 10);
          const dt = new Date(y, m - 1, d);
          return dt.toLocaleDateString("en-US", {
            weekday: "long",
            month: "long",
            day: "numeric",
          });
        }
      }
      const dt = new Date(dateOnly || dateStr);
      if (isNaN(dt)) return dateStr;
      return dt.toLocaleDateString("en-US", {
        weekday: "long",
        month: "long",
        day: "numeric",
      });
    } catch (e) {
      return dateStr;
    }
  };

  const formatTime = (timeStr) => {
    if (!timeStr) return "";
    const t = String(timeStr).trim();
    // If already contains AM/PM, normalize spacing and uppercase
    if (/[AP]M$/i.test(t.replace(/\s+/g, ""))) {
      return t.replace(/\s+/g, "").toUpperCase();
    }
    // if format HH:MM (24h or 12h without AM/PM)
    const m = t.match(/^(\d{1,2}):(\d{2})$/);
    if (m) {
      let hh = parseInt(m[1], 10);
      const mm = m[2];
      const ampm = hh >= 12 ? "PM" : "AM";
      hh = hh % 12 || 12;
      return `${hh}:${mm}${ampm}`;
    }
    return t;
  };

  // useEffect(() => {
  //   dispatch(getSingleBooking(data.bookingFiles.map((i) => i.bookingId)));
  // }, []);
  return (
    <div className="w-full bg-white rounded-[18px] border-[1px] border-[#7876A1] p-3 mb-4 font-instrument">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <span
            className={`inline-block text-[11px] sm:text-[13px] font-semibold px-2 sm:px-3 py-1 rounded-full uppercase tracking-wide ${
              (data?.status || "").toLowerCase() === "pending"
                ? "bg-yellow-100 text-yellow-800"
                : (data?.status || "").toLowerCase() === "confirmed"
                ? "bg-blue-100 text-blue-800"
                : (data?.status || "").toLowerCase() === "completed"
                ? "bg-green-100 text-green-800"
                : "bg-gray-100 text-gray-800"
            }`}
          >
            {data?.status || ""}
          </span>
        </div>

        <div className="text-xs sm:text-sm text-[#3E3A98] font-medium">
          <div className="text-sm sm:text-sm">{formatDate(data?.deliveryDate)}</div>
          {data?.exactTime && (
            <div className="mt-1 text-xs sm:text-sm bg-[#34318C] rounded-[5px] text-white text-center py-1 px-2">{formatTime(data?.exactTime)}</div>
          )}
        </div>
      </div>

      <div className="mt-4">
        <p className="mb-1" style={{ color: "#7876A1", fontWeight: 700, fontSize: "11px" }}>Pickup</p>
        <h3 className="text-[#211F59] font-semibold text-sm sm:text-base leading-tight">{data?.pickupLocation}</h3>

        {data?.stops?.length > 0 && (
          <div className="mt-3">
            <p className="mb-1" style={{ color: "#7876A1", fontWeight: 700, fontSize: "11px" }}>Stops</p>
            <div className="space-y-3">
              {data.stops.map((stop, idx) => (
                <div key={idx} className="flex items-start gap-3 text-[#211F59]">
                  <span className="w-2 h-2 rounded-full mt-2 bg-[#C5C0F0]" />
                  <div className="flex-1 min-w-0">
                    <p className="mb-1" style={{ color: "#7876A1", fontWeight: 700, fontSize: "11px" }}>
                      {data?.stops?.length > 1 ? `Stop ${String.fromCharCode(65 + idx)}` : "Stop"}
                    </p>
                    <h3 className="text-[#211F59] font-semibold text-sm sm:text-base leading-tight truncate">{stop?.stop}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <p className="mt-3 mb-1" style={{ color: "#7876A1", fontWeight: 700, fontSize: "11px" }}>Drop-off</p>
        <h3 className="text-[#211F59] font-semibold text-sm sm:text-base leading-tight">{data?.dropoffLocation}</h3>
      </div>

      <div className="mt-4 border-t border-[#7876A180] pt-3 flex items-center justify-between">
        <div className="text-xs sm:text-sm text-[#7876A1]">{data?.labourNeeded ? `${data.labourNeeded} Movers |` : ""} {moversVehicle} </div>
        <div className="flex items-center gap-3">
          <button
            style={{border : "1px solid #211F59"}}
            onClick={() => history(`/singleTrip/${userInfo?.id}/${data?.id}`)}
            className="px-3 py-1 sm:px-4 sm:py-2 rounded-full text-[#211F59] text-sm font-medium"
          >
            View Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default TripCard;
